import { ThunkAction } from 'redux-thunk';
import { Action, ActionType } from 'app/pages/DiscountsList/actionTypes';
import { loadPage } from 'app/pages/DiscountsList/loadPage';
import { getDiscountFilters } from 'app/pages/DiscountsList/modules/DiscountItemsList/selectors';
import { ProductStatusFilterValue } from 'app/shared/components/productStatusFilterUtils';

type FilterThunk = ThunkAction<Promise<void>, any, any, Action>;

export const changeStatusFilter = (statusFilter: ProductStatusFilterValue): FilterThunk =>
    async (dispatch, getState) => {
        dispatch({ type: ActionType.ChangeStatusFilter, statusFilter });
        await loadPage(dispatch, undefined, getDiscountFilters(getState()));
    };

export const changeTypeFilter = (types: string[]): FilterThunk =>
    async (dispatch, getState) => {
        dispatch({ type: ActionType.ChangeTypeFilter, types });
        await loadPage(dispatch, undefined, getDiscountFilters(getState()));
    };

export const changeSchoolFilter = (schoolIds: string[]): FilterThunk =>
    async (dispatch, getState) => {
        dispatch({ type: ActionType.ChangeSchoolFilter, schoolIds });
        await loadPage(dispatch, undefined, getDiscountFilters(getState()));
    };

export const changeSortOrder = (sortOrder: string): FilterThunk =>
    async (dispatch, getState) => {
        dispatch({ type: ActionType.ChangeSortOrder, sortOrder });
        await loadPage(dispatch, undefined, getDiscountFilters(getState()));
    };

export const resetFilters = (): FilterThunk =>
    async (dispatch, getState) => {
        dispatch({ type: ActionType.ResetFilters });
        await loadPage(dispatch, undefined, getDiscountFilters(getState()));
    };